import React, { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { SmilePlus } from "lucide-react";

const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🔥", "🎉", "👏"];

export function ReactionChips({ reactions, myId, onToggle }) {
  const entries = Object.entries(reactions || {});
  if (!entries.length) return null;
  return (
    <div className="flex items-center gap-1 mt-1 flex-wrap" data-testid="reaction-chips">
      {entries.map(([emoji, users]) => {
        const mine = users.includes(myId);
        return (
          <button
            key={emoji}
            data-testid={`reaction-chip-${emoji}`}
            onClick={() => onToggle(emoji)}
            className={`text-[12px] font-black border-hard-2 rounded-full px-2 py-0.5 press-btn shadow-hard-sm ${mine ? "bg-[#CCFF00]" : "bg-white"}`}
          >
            {emoji} <span className="tabular-nums">{users.length}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function ReactionPicker({ messageId, isMe, currentReactions, myId, onChanged }) {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const toggle = async (emoji) => {
    try {
      const { data } = await api.post(`/messages/${messageId}/react`, { emoji });
      onChanged?.(data.reactions || {});
    } catch {}
    setOpen(false);
  };

  return (
    <div className={`relative ${isMe ? "self-start ml-1" : "self-end mr-1"}`} ref={boxRef}>
      <button
        onClick={() => setOpen((s) => !s)}
        data-testid={`react-toggle-${messageId}`}
        className="w-6 h-6 rounded-full border-hard-2 bg-white flex items-center justify-center press-btn shadow-hard-sm opacity-70 hover:opacity-100"
        aria-label="Tepki ver"
      >
        <SmilePlus strokeWidth={3} className="w-3 h-3" />
      </button>
      {open && (
        <div
          data-testid="reaction-picker"
          className={`absolute bottom-full mb-1 ${isMe ? "left-0" : "right-0"} bg-white border-hard shadow-hard rounded-full px-2 py-1 flex items-center gap-1 z-20`}
        >
          {QUICK_REACTIONS.map((e) => (
            <button
              key={e}
              data-testid={`react-pick-${e}`}
              onClick={() => toggle(e)}
              className="text-lg leading-none hover:scale-125 transition-transform"
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export { QUICK_REACTIONS };
